import rebateDistributionTask from './rebateDistributionTask';
import rebateRecord from './rebateRecord';

export default { rebateDistributionTask, rebateRecord };
